import React from 'react'
import axios from "axios";
import { BaseUrl } from "./BaseUrl";

const getCacheScopes = (endpoint) => {
  const path = endpoint.toLowerCase();
  const scopes = [];

  if (path.includes("aiblog")) scopes.push("aiBlog");
  else if (path.includes("blog")) scopes.push("blog");

  if (path.includes("author") || path.includes("tag") || path.includes("blog-categor")) {
    scopes.push("blog", "aiBlog");
  }
  if (path.includes("casestudy")) scopes.push("caseStudy");
  if (path.includes("media")) scopes.push("media");
  if (path.includes("feature")) scopes.push("feature");
  if (path.includes("cloneapp")) scopes.push("cloneApp");
  if (path.includes("logo")) scopes.push("logo");
  if (path.includes("testimonial")) scopes.push("testimonial");
  if (path.includes("seo")) scopes.push("seo");
  if (path.includes("schema")) scopes.push("globalSchema");
  if (path.includes("faq")) scopes.push("faq");
  if (path.includes("robots")) scopes.push("robots");

  return [...new Set(scopes)];
};

const ApiRequest = async (method, endpoint, payload = {}, options = {}) => {

  const token =
    typeof window !== "undefined"
      ? localStorage.getItem("accessToken")
      : null;

  const defaultHeaders = {
    ...(token && {
      "x-access-token": token,
    }),
  };

  const mergedHeaders = {
    ...defaultHeaders,
    ...(options.headers || {}),
  };

  const normalizedMethod = method.toUpperCase();
  try {
    let response = null;
    switch (normalizedMethod) {
      case "POST":
        response = await axios.post(BaseUrl + endpoint, payload, { headers: mergedHeaders });
        break;

      case "GET":
        response = await axios.get(BaseUrl + endpoint, {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            ...mergedHeaders,
          },
        });
        break;

      // case "PUT":
      //   response = await axios.put(BaseUrl + endpoint, payload, headers);
      //   break;

      // case "DELETE":
      //   response = await axios.delete(BaseUrl + endpoint, payload, headers.headers);
      //   break;

      default:
        throw new Error(`Invalid method: ${method}`);
    }

    // Invalidate only the affected website data after a successful admin mutation.
    if (normalizedMethod !== "GET" && token) {
      const scopes = getCacheScopes(endpoint);
      if (scopes.length) {
        try {
          await axios.post(
            "/__admin/cache/invalidate",
            { scopes },
            { headers: { "x-access-token": token, "Cache-Control": "no-store" } }
          );
        } catch (invalidationError) {
          // The content mutation succeeded; don't report it as failed because a
          // separate cache invalidation request had a transient error.
          console.error("Unable to invalidate website cache:", invalidationError);
        }
      }
    }

    return response.data;
  } catch (error) {
    if (
      typeof window !== "undefined" &&
      (error?.response?.status === 401 || error?.response?.status === 403)
    ) {
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }
    throw error;
  }
};

export default ApiRequest;
